module.exports = __webpack_public_path__ + "static/woman-boy-square.56ed449c.jpg";